import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { Actions as reportActions } from "../../core/redux/ducks/report";
import { Actions as articleActions } from "../../core/redux/ducks/article";
import { Creators as appActions } from "../../core/redux/ducks/app";
import { Filter } from "./Filter";
import { ArticlePaper } from "./ArticlePaper";
import { DragDropContext } from "react-beautiful-dnd";
import { SnipptSourceList } from "./SnippetSourceList";
import { IFrameModal } from "../../components/IFrameModal";
import { Prompt } from "react-router";
import { FilterContainer } from "./style/styledComponents";
import "./style/style.css";
import { Box } from "@material-ui/core";
import ArticleEditor from "../editor/ArticleEditor";
import TagModal from "./TagModal";

function Article({
  history,
  articleState,
  reportState,
  fetchArticleById,
  fetchReports,
  fetchMoreReports,
  saveSnippet,
  deleteSnippet,
  saveArticle,
  saveSnippets,
  reorderSnippets,
  isArticlePaperOpen,
  showHideToggleArticlePaper,
  // addSnippetToEditor,
}) {
  const [isOpenSourceMordal, setOpenSourceMordal] = useState(false);
  const [iframeSource, setIframeSource] = useState({});
  const [isOpenTagMordal, openTagModal] = useState(false);
  const [activeTab, setActiveTab] = useState(
    history.location?.state?.status ? "editor" : "search"
  );
  const { article, status, error } = articleState;
  const [editorContent, setContent] = useState("");

  const editorRef = useRef(null);
  const paperRef = useRef(null);

  const onDragEnd = async (result) => {
    paperRef.current.focus();
    const { destination, source, draggableId } = result;
    if (!destination) return;
    if (destination.droppableId === "column-article") {
      if (destination.droppableId === source.droppableId) {
        reorderSnippets(source.index, destination.index);
      } else {
        const [$1, sourceId, snippetId] = draggableId.split("-");
        // const reportDra = reportState.reports.reports.find(report => repo)
        const snippetDrag =
          reportState.reports.reports[sourceId].snippets[snippetId];
        const sourceReport = reportState.reports.reports[sourceId].source;
        const position = destination.index;

        saveSnippet(
          {
            ...snippetDrag,
            source: {
              ...sourceReport,
              url: reportState.reports.reports[sourceId].url,
            },
          },
          article.id,
          position
        );
      }
    }
    if (destination.droppableId === "column-editor") {
      const snippet = article.snippets[source.index];
      const newContent = snippet.text.link(snippet.reportUrl);
      // editorRef.current.value = newContent;
      setContent(newContent);
    }
  };

  useEffect(() => {
    if (history.location.state) {
      if (history.location.state.status) {
        showHideToggleArticlePaper(true);
      }
      const key =
        history.location.state.keywords || history.location.state.keyword;
      const params = {
        ...reportState.filterParams,
        keywords: key || "",
        page: 1,
      };
      if (history.location.state.articleid) {
        fetchArticleById(history.location.state.articleid);
      } else {
        if (history.location.state.action === "save") {
          const folderId = history.location.state.folderId;
          const newArticle = {
            name: history.location.state.keywords,
            snippets: [],
          };
          saveArticle(newArticle, folderId ? folderId : null);
        }
      }
      fetchReports(params);
    }
  }, [history.location.state]);

  useEffect(() => {
    let key = "";
    if (history.location.state) {
      key =
        history.location.state.keywords || history.location.state.keyword || "";
    }
    const params = {
      ...reportState.filterParams,
      keywords: key,
    };
    fetchReports(params);
  }, []);

  const handleScroll = (event) => {
    if (
      reportState &&
      reportState.reports &&
      reportState.reports.hasMorePages &&
      !reportState.loadingMore
    ) {
      const isBottom =
        Math.round(event.target.scrollHeight - event.target.scrollTop) ===
        event.target.clientHeight;
      if (isBottom) {
        fetchMoreReports({
          ...reportState.filterParams,
        });
      }
    }
  };

  const filterFormHandler = (newFilterParams) => {
    const params = {
      ...reportState.filterParams,
      ...newFilterParams,
      page: 1,
      categories: newFilterParams.categories.join(","),
      regions: newFilterParams.regions.join(","),
    };
    fetchReports(params);
  };

  function handleCloseSourceModal(url) {
    setOpenSourceMordal(false);
    setIframeSource({});
  }

  return (
    <Box display="flex" width={1} overflow="hidden">
      <DragDropContext onDragEnd={(result) => onDragEnd(result)}>
        {activeTab === "search" ? (
          <FilterContainer onScroll={(e) => handleScroll(e)} maxWidth="xl">
            {iframeSource && iframeSource.url ? (
              <div className="left-modal">
                <iframe
                  src={iframeSource.url}
                  className="ifrmemodel"
                  title={iframeSource.url}
                />
              </div>
            ) : (
              <>
                <Filter
                  filterChange={filterFormHandler}
                  loading={reportState.loading}
                />
                <SnipptSourceList
                  article={article}
                  reports={reportState.reports}
                  loadingReports={reportState.loading}
                  loadingMoreReports={reportState.loadingMore}
                  saveSnippet={saveSnippet}
                  setIframeSource={setIframeSource}
                  setOpenSourceMordal={setOpenSourceMordal}
                  saveSnippets={saveSnippets}
                />
              </>
            )}
          </FilterContainer>
        ) : (
          <ArticleEditor
            editorRef={editorRef}
            setContent={setContent}
            editorContent={editorContent}
          />
        )}
        <ArticlePaper
          article={article}
          onHide={() => showHideToggleArticlePaper(false)}
          isArticlePaperOpen={isArticlePaperOpen}
          setOpenArticlePaper={showHideToggleArticlePaper}
          deleteSnippet={deleteSnippet}
          saveArticle={saveArticle}
          saveSnippet={saveSnippet}
          frameSource={iframeSource}
          status={status}
          error={error}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          openTagModal={() => openTagModal(true)}
        />
        <IFrameModal
          show={isOpenSourceMordal}
          iframeUrl={iframeSource.url}
          handleClose={handleCloseSourceModal}
        />
        <Prompt
          when={article && !article.id && article.snippets.length > 0}
          message="You have unsaved changes, are you sure you want to leave?"
        />
      </DragDropContext>
      <TagModal
        isOpen={isOpenTagMordal}
        onClose={() => openTagModal(false)}
        articleId={article?.id}
      />
      <input type="hidden" ref={paperRef} />
    </Box>
  );
}

const mapStateToProps = (state) => {
  return {
    reportState: state.report,
    articleState: state.article,
    isArticlePaperOpen: state.app.isArticlePaperOpen,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchReports: (params) => reportActions.fetchReports(dispatch, params),
    fetchMoreReports: (params) =>
      reportActions.fetchMoreReports(dispatch, params),
    saveArticle: (newArticle, folderId) =>
      articleActions.saveArticle(dispatch, newArticle, folderId),
    fetchArticleById: (id) => articleActions.fetchArticleById(dispatch, id),
    showHideToggleArticlePaper: () =>
      dispatch(appActions.showHideToggleArticlePaper()),
    saveSnippet: (snippet, articleID, position) =>
      articleActions.addSnippet(dispatch, snippet, articleID, position),
    saveSnippets: (snippets, source, articleID) =>
      articleActions.addSnippets(dispatch, snippets, source, articleID),
    deleteSnippet: (snippet, articleId) =>
      articleActions.deleteSnippet(dispatch, snippet, articleId),
    reorderSnippets: (sourceIndex, destinationIndex, draggabledId) =>
      dispatch(articleActions.reorderSnippets(sourceIndex, destinationIndex)),
    addSnippetToEditor: (snippet, newContent) =>
      dispatch(articleActions.addSnippetToEditor(snippet, newContent)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Article);
